// source: types/features.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.types.Feature', null, global);
goog.exportSymbol('proto.types.PaidFeature', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.types.PaidFeature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.types.PaidFeature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.types.PaidFeature.displayName = 'proto.types.PaidFeature';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.types.PaidFeature.prototype.toObject = function(opt_includeInstance) {
  return proto.types.PaidFeature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.types.PaidFeature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.PaidFeature.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    price: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.types.PaidFeature}
 */
proto.types.PaidFeature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.types.PaidFeature;
  return proto.types.PaidFeature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.types.PaidFeature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.types.PaidFeature}
 */
proto.types.PaidFeature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.types.Feature} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.types.PaidFeature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.types.PaidFeature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.types.PaidFeature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.types.PaidFeature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional Feature type = 1;
 * @return {!proto.types.Feature}
 */
proto.types.PaidFeature.prototype.getType = function() {
  return /** @type {!proto.types.Feature} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.types.Feature} value
 * @return {!proto.types.PaidFeature} returns this
 */
proto.types.PaidFeature.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string price = 2;
 * @return {string}
 */
proto.types.PaidFeature.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.PaidFeature} returns this
 */
proto.types.PaidFeature.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.types.PaidFeature.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.types.PaidFeature} returns this
 */
proto.types.PaidFeature.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.types.Feature = {
  AUTOMATIONS: 0,
  SIMULATOR: 1,
  TARIFF_SWITCH: 2,
  TIPS: 3,
  SHOP: 4,
  ENERGY_TARIFF: 5,
  WATER_TARIFF: 6,
  GAS_TARIFF: 7,
  LATEST_STATUS: 8,
  CURRENT_MONTH_OVERVIEW: 9,
  SPACE_COMPARISON: 10,
  INVOICES: 11,
  DEVICES_CONFIG: 12,
  SPACE_CONFIG: 13,
  MARKET_PREMIUM: 14,
  VIRTUAL_SUM_METER: 15,
  SPACE_KPIS: 16,
  CHILD_PARTNER_CREATION: 17,
  REPORTING: 18,
  LANDLORD_TO_TENANT_COST: 19,
  REFERENCE_VALUES: 20,
  EDIT_TARIFF_DETAILS: 21,
  TARIFF_ADVANCE_PAYMENTS: 22,
  ONE_SPACE: 23,
  UP_TO_TWO_SPACES: 24,
  UNLIMITED_SPACES: 25,
  ONE_DEVICE: 26,
  UNLIMITED_DEVICES: 27,
  CSV_EXPORT: 28,
  CHILD_SPACES: 29,
  CONSUMPTION_VISUALISATION: 30,
  POWERFOX: 31,
  CREATE_INVITES: 32,
  COST_CALCULATION: 33,
  CONSUMPTION_TARGET: 34,
  CONNECT_TIBBER_DEVICES: 35,
  COMMERCIAL_SPACES: 36,
  SUPPORT_48H: 37,
  SMART_AND_RLM_METER: 38,
  SUPPORT_3D: 39,
  CONNECT_IOMETER_DEVICES: 40
};

goog.object.extend(exports, proto.types);
